<template>
  <div class="bg-white">
    <CoverPage />
    <div class="pt-40rem">
      <AboutUs />
      <MedicalCon />
      <News />
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import AboutUs from "./components/AboutUs.vue";
import MedicalCon from "./components/MedicalCondition.vue";
import CoverPage from "./components/CoverPage.vue";
import DownloadApp from "../../home/components/DownloadApp.vue";
import Footer from "../../Footer.vue";
import News from "../home/components/LatestNews.vue";
export default {
  components: {
    CoverPage,
    MedicalCon,
    AboutUs,
    DownloadApp,
    Footer,
    News,
  },
  metaInfo: {
    title: "Online Course for Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Our unique & certified courses help build your capacity to provide better care for the chronically ill. Available for individuals and healthcare professionals",
      },
    ],
  },
};
</script>
<style>
.pt-40rem {
  padding-top: 40rem;
}
</style>
